/**
 * Auth API Service
 */

import { apiClient } from '../client';
import type {
  ApiResponse,
  CheckBindingResponse,
  BindEmployeeRequest,
  BindEmployeeResponse,
  UserProfile,
} from '../../types';

const API_PREFIX = '/api/saiens/auth';

/**
 * Check if LINE account is bound to employee
 */
export async function checkBinding(lineUserId: string): Promise<ApiResponse<CheckBindingResponse>> {
  const response = await apiClient.post<ApiResponse<CheckBindingResponse>>(
    `${API_PREFIX}/check-binding`,
    { line_user_id: lineUserId }
  );
  return response.data;
}

/**
 * Bind LINE account to employee
 */
export async function bindEmployee(
  data: BindEmployeeRequest
): Promise<ApiResponse<BindEmployeeResponse>> {
  const response = await apiClient.post<ApiResponse<BindEmployeeResponse>>(
    `${API_PREFIX}/bind`,
    data
  );
  return response.data;
}

/**
 * Get current user profile
 */
export async function getCurrentUser(): Promise<ApiResponse<UserProfile>> {
  const response = await apiClient.get<ApiResponse<UserProfile>>(`${API_PREFIX}/me`);
  return response.data;
}

/**
 * Logout
 */
export async function logout(): Promise<ApiResponse<void>> {
  const response = await apiClient.post<ApiResponse<void>>(`${API_PREFIX}/logout`);
  return response.data;
}

/**
 * Unbind LINE account
 */
export async function unbindEmployee(): Promise<ApiResponse<void>> {
  const response = await apiClient.post<ApiResponse<void>>(`${API_PREFIX}/unbind`);
  return response.data;
}
